import { createStructuredSelector } from "reselect";
import {
    ACT_TYPE_LIST, ACT_TYPE_LIST_SUCCESS, ACT_TYPE_LIST_ERROR,
    ACT_TYPE_LIST_SEARCH_CHANGE, ACT_TYPE_LIST_PAGE_SET,
    ACT_TYPE_ADD_MODAL_SET, ACT_TYPE_ADD_CHANGE_SET,
    ACT_TYPE_ADD, ACT_TYPE_ADD_SUCCESS, ACT_TYPE_ADD_ERROR,
    ACT_TYPE_GET, ACT_TYPE_GET_SUCCESS, ACT_TYPE_GET_ERROR,
    ACT_TYPE_VIEW_MODAL_SET,
    ACT_TYPE_EDIT_MODAL_SET, ACT_TYPE_EDIT_CHANGE_SET,
    ACT_TYPE_EDIT, ACT_TYPE_EDIT_SUCCESS, ACT_TYPE_EDIT_ERROR
} from "../actions";

export const NAME = 'taskType';

// List
export const TypeActList = (page, num_page, orderBy, filters) => ({ type: ACT_TYPE_LIST, payload: { page, num_page, orderBy, filters } });
export const TypeActListSuccess = (data) => ({ type: ACT_TYPE_LIST_SUCCESS, payload: data });
export const TypeActListError = (error) => ({ type: ACT_TYPE_LIST_ERROR, payload: error });
export const TypeActListSearchChange = (data) => ({ type: ACT_TYPE_LIST_SEARCH_CHANGE, payload: data });
export const TypeActListPageSet = (data) => ({ type: ACT_TYPE_LIST_PAGE_SET, payload: data });

// Add
export const TypeActAddModalSet = (data) => ({ type: ACT_TYPE_ADD_MODAL_SET, payload: data });
export const TypeActAddChangeSet = (data) => ({ type: ACT_TYPE_ADD_CHANGE_SET, payload: data });
export const TypeActAdd = (page, num_page, orderBy, filters, data) => ({ type: ACT_TYPE_ADD, payload: { page, num_page, orderBy, filters, data } });
export const TypeActAddSuccess = (data) => ({ type: ACT_TYPE_ADD_SUCCESS, payload: data });
export const TypeActAddError = (error) => ({ type: ACT_TYPE_ADD_ERROR, payload: error });

// Get (detail)
export const TypeActGet = (id_task_type) => ({ type: ACT_TYPE_GET, payload: { id_task_type } });
export const TypeActGetSuccess = (data) => ({ type: ACT_TYPE_GET_SUCCESS, payload: data });
export const TypeActGetError = (error) => ({ type: ACT_TYPE_GET_ERROR, payload: error });

// View modal
export const TypeActViewModalSet = (data) => ({ type: ACT_TYPE_VIEW_MODAL_SET, payload: data });

// Edit
export const TypeActEditModalSet = (data) => ({ type: ACT_TYPE_EDIT_MODAL_SET, payload: data });
export const TypeActEditChangeSet = (data) => ({ type: ACT_TYPE_EDIT_CHANGE_SET, payload: data });
export const TypeActEdit = (page, num_page, orderBy, filters, data) => ({ type: ACT_TYPE_EDIT, payload: { page, num_page, orderBy, filters, data } });
export const TypeActEditSuccess = (data) => ({ type: ACT_TYPE_EDIT_SUCCESS, payload: data });
export const TypeActEditError = (error) => ({ type: ACT_TYPE_EDIT_ERROR, payload: error });

const taskType = (state) => state[NAME];
export const TaskTypeSelector = createStructuredSelector({ taskType });
